import Vue from 'vue'
import router from '../router/index'
import axios from 'axios'
import utils, { ua } from './utils'
import QS from 'qs'
import jsonLong from 'json-bigint'
import store from '@/store'
import fetch from '@/axios/fetch'

window.parameter = utils.getParams()
window.parameter.token = sessionStorage.getItem('token') || ''

axios.defaults.transformResponse = function(data) {
  return jsonLong.parse(data)
}

axios.interceptors.request.use(config => {
  return config
}, error => Promise.reject(error))

axios.interceptors.response.use(response => {
  if (response.data.code && response.data.code < 0) {
    const data = {
      currentModule: document.location.hash,
      locationOrigin: document.location.host,
      locationPathname: response.config.url,
      locationSearch: document.location.search,
      requestMethod: response.config.method,
      requestHeaders: response.config.headers,
      requestBody: response.config.data,
      statusCode: response.status,
      responseHeader: response.headers,
      responseBody: response.data,
      deviceName: navigator.appName,
      deviceVersion: navigator.appVersion,
      deviceModel: navigator.userAgent,
      networkStatus: navigator.onLine,
      platformType: navigator.platform,
      appVersion: navigator.appVersion,
      operatorUserId: store.state.token.data.userId,
      operatorUserName: store.state.token.data.userName,
      operatorUserTelephone: store.state.token.data.uid,
      token: store.state.token.data.token,
      appCode: store.state.token.data.appCode,
      tenantId: store.state.token.tenantId,
      operatorTime: response.data.timestamp,
      remark: '无'
    }
    // sessionStorage.setItem('response', JSON.stringify(data))
    fetch.addExceptionLog(data)
  }
  return response
}, error => {
  const data = {
    currentModule: document.location.hash,
    locationOrigin: document.location.host,
    locationPathname: error.response.config.url,
    locationSearch: document.location.search,
    requestMethod: error.response.config.method,
    requestHeaders: error.response.config.headers,
    requestBody: error.response.config.data,
    statusCode: error.response.status,
    responseHeader: error.response.headers,
    responseBody: error.response.data,
    deviceName: navigator.appName,
    deviceVersion: navigator.appVersion,
    deviceModel: navigator.userAgent,
    networkStatus: navigator.onLine,
    platformType: navigator.platform,
    appVersion: navigator.appVersion,
    operatorUserId: store.state.token.data.userId,
    operatorUserName: store.state.token.data.userName,
    operatorUserTelephone: store.state.token.data.uid,
    token: store.state.token.data.token,
    appCode: store.state.token.data.appCode,
    tenantId: store.state.token.tenantId,
    operatorTime: error.response.data.timestamp,
    remark: '无'
  }
  // sessionStorage.setItem('response', JSON.stringify(data))
  fetch.addExceptionLog(data)
})

var checkStatus = response => {
  if (response.status === 200 || response.status === 304) {
    return response.data
  }
  setTimeout(_ => { Vue.$vux.loading.hide(200) }, 500)
  Vue.$vux.toast.text('服务器错误,错误状态码为:' + response.status, 'middle')
  return {
    status: true,
    code: response.status,
    message: response.statusText,
    data: response.statusText
  }
}
var checkCode = res => {
  if (res.status) {
    return res
  }
  if (res.code === 10102) {
    Vue.$vux.toast.text(res.message, 'middle')
    store.dispatch('setToken', false)
    store.dispatch('setUserInfo', {})
    router.push({ path: '/login' })
  } else if (res.code === 2) {
  } else if (res.code !== 0) {
    Vue.$vux.toast.text(res.message, 'middle')
  }
  setTimeout(_ => { Vue.$vux.loading.hide(200) }, 500)
  return res
}
var post = (url, data, isShowLoading = true) => {
  // isShowLoading && Vue.$vux.loading.show({
  //   text: ' '
  // })

  var tokenInfo = store.state.token.data || { token: '' }
  var tenantId = utils.getLocalStorage('tenantId') || ''
  /* appCode: 应用代码 全局 */
  data = {
    appCode: Vue.prototype.$config.appCode,
    tenantId: tenantId,
    // pageSize:'9999',
    ...data
  }
  return axios({
    method: 'post',
    url: `${Vue.prototype.$config.host}${url}?token=${window.parameter.token || tokenInfo.token}`,
    data,
    timeout: 30000,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json'
    }
  }).then(checkStatus).then(checkCode)
}
var post2 = (url, data, isShowLoading) => {
  !(data instanceof FormData) && (data = QS.stringify(data))
  return axios({
    method: 'post',
    url: `${Vue.prototype.$config.host}${url}`,
    data,
    timeout: 30000,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  }).then(checkStatus).then(checkCode)
}
var get = (url, params) => {
  return axios({
    method: 'get',
    url,
    params,
    timeout: 30000,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(checkStatus).then(checkCode)
}
Vue.prototype.post = post
Vue.prototype.post2 = post2

Vue.prototype.get = get
Vue.prototype.$common = Object.assign({}, utils, {
})



// WEBPACK FOOTER //
// ./src/axios/index.js